// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3QMG0","inputDescription":"styles_inputDescription__1J7Ez"};